import { render, staticRenderFns } from "./PerformanceDetail.vue?vue&type=template&id=0c067486&scoped=true"
import script from "./PerformanceDetail.vue?vue&type=script&lang=js"
export * from "./PerformanceDetail.vue?vue&type=script&lang=js"
import style0 from "./PerformanceDetail.vue?vue&type=style&index=0&id=0c067486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c067486",
  null
  
)

export default component.exports